import companyAccess from "./CompanyAccess";

export const showMenu = (key) => {
  const userCid = localStorage.getItem("tenant")?.toLowerCase();
  return companyAccess[key]?.some(
    (cid) => cid.toLowerCase() === userCid
  );
};
